// Collab Pricing Calculator, Pricing Approval and Inline Cost Sheets — the screen's strings in the portal's four languages (2026-10-21).
const en = {
  paImported: "Read {{n}} item(s) from the Price Approval workbook ({{sheets}}) — check the numbers, then Save project.",
  moveFailed: "Move failed ({{status}})",
  createFailed: "Create failed ({{status}})",
  renameFailed: "Rename failed ({{status}})",
  saveFailed: "Save failed ({{status}})",
  photoUploadFailed: "Photo upload failed ({{status}})",
  photosPartial: "{{sent}} of {{total}} photo(s) uploaded — {{error}}",
  photosSent: "{{n}} photo(s)",
  messageFailed: "Message failed ({{status}})",
  messagesPartial: "{{sent}} of {{total}} message(s) posted — {{error}}",
  messagesSent: "{{n}} message(s)",
  actionFailed: "{{action}} failed ({{status}})",
  failed: "Failed ({{status}})",
  searchLibraryFailed: "Could not search the library",
  fileUnreadable: "The file could not be read.",
  readFileFailed: "Could not read that file",
  importFailed: "Import failed ({{status}})",
  noRowsInFile: "The file had no rows to read",
  loadFailed: "Load failed ({{status}})",
  deleteFailed: "Delete failed ({{status}})",
  exportFailed: "Export failed ({{status}})",
  nDays: "{{n}} days",
  rateNone: "none",
  locked: "locked",
  selectAll: "Select all",
  approve: "Approve",
  loadLibraryFailed: "Could not load the library",
  readSheetFailed: "Could not read that sheet",
  saveFailedPlain: "Could not save",
  removeSheetFailed: "Could not remove that sheet",
};
const ko = {
  paImported: "Price Approval 파일에서 {{n}}개 품목을 읽었습니다 ({{sheets}}) — 숫자를 확인한 뒤 Save project를 누르세요.",
  moveFailed: "이동 실패 ({{status}})",
  createFailed: "생성 실패 ({{status}})",
  renameFailed: "이름 변경 실패 ({{status}})",
  saveFailed: "저장 실패 ({{status}})",
  photoUploadFailed: "사진 업로드 실패 ({{status}})",
  photosPartial: "사진 {{total}}장 중 {{sent}}장 업로드됨 — {{error}}",
  photosSent: "사진 {{n}}장",
  messageFailed: "메시지 전송 실패 ({{status}})",
  messagesPartial: "메시지 {{total}}건 중 {{sent}}건 게시됨 — {{error}}",
  messagesSent: "메시지 {{n}}건",
  actionFailed: "{{action}} 실패 ({{status}})",
  failed: "실패 ({{status}})",
  searchLibraryFailed: "라이브러리를 검색할 수 없습니다",
  fileUnreadable: "파일을 읽을 수 없습니다.",
  readFileFailed: "해당 파일을 읽을 수 없습니다",
  importFailed: "가져오기 실패 ({{status}})",
  noRowsInFile: "파일에 읽을 행이 없습니다",
  loadFailed: "불러오기 실패 ({{status}})",
  deleteFailed: "삭제 실패 ({{status}})",
  exportFailed: "내보내기 실패 ({{status}})",
  nDays: "{{n}}일",
  rateNone: "없음",
  locked: "잠김",
  selectAll: "전체 선택",
  approve: "승인",
  loadLibraryFailed: "라이브러리를 불러올 수 없습니다",
  readSheetFailed: "해당 시트를 읽을 수 없습니다",
  saveFailedPlain: "저장할 수 없습니다",
  removeSheetFailed: "해당 시트를 삭제할 수 없습니다",
};
const vi = {
  paImported: "Đã đọc {{n}} item từ file Price Approval ({{sheets}}) — kiểm tra số rồi bấm Save project.",
  moveFailed: "Không chuyển được ({{status}})",
  createFailed: "Không tạo được ({{status}})",
  renameFailed: "Không đổi tên được ({{status}})",
  saveFailed: "Không lưu được ({{status}})",
  photoUploadFailed: "Không tải ảnh lên được ({{status}})",
  photosPartial: "Đã tải lên {{sent}}/{{total}} ảnh — {{error}}",
  photosSent: "{{n}} ảnh",
  messageFailed: "Không gửi được tin nhắn ({{status}})",
  messagesPartial: "Đã đăng {{sent}}/{{total}} tin nhắn — {{error}}",
  messagesSent: "{{n}} tin nhắn",
  actionFailed: "{{action}} không thành công ({{status}})",
  failed: "Không thành công ({{status}})",
  searchLibraryFailed: "Không tìm được trong thư viện",
  fileUnreadable: "Không đọc được tệp.",
  readFileFailed: "Không đọc được tệp đó",
  importFailed: "Nhập không thành công ({{status}})",
  noRowsInFile: "Tệp không có dòng nào để đọc",
  loadFailed: "Không tải được ({{status}})",
  deleteFailed: "Không xóa được ({{status}})",
  exportFailed: "Xuất không thành công ({{status}})",
  nDays: "{{n}} ngày",
  rateNone: "không",
  locked: "đã khóa",
  selectAll: "Chọn tất cả",
  approve: "Duyệt",
  loadLibraryFailed: "Không tải được thư viện",
  readSheetFailed: "Không đọc được bảng đó",
  saveFailedPlain: "Không lưu được",
  removeSheetFailed: "Không xóa được bảng đó",
};
const zh = {
  paImported: "已从 Price Approval 文件读取 {{n}} 个品项（{{sheets}}）— 请核对数字后点击 Save project。",
  moveFailed: "移动失败（{{status}}）",
  createFailed: "创建失败（{{status}}）",
  renameFailed: "重命名失败（{{status}}）",
  saveFailed: "保存失败（{{status}}）",
  photoUploadFailed: "照片上传失败（{{status}}）",
  photosPartial: "已上传 {{sent}}/{{total}} 张照片 — {{error}}",
  photosSent: "{{n}} 张照片",
  messageFailed: "消息发送失败（{{status}}）",
  messagesPartial: "已发布 {{sent}}/{{total}} 条消息 — {{error}}",
  messagesSent: "{{n}} 条消息",
  actionFailed: "{{action}} 失败（{{status}}）",
  failed: "失败（{{status}}）",
  searchLibraryFailed: "无法搜索资料库",
  fileUnreadable: "无法读取该文件。",
  readFileFailed: "无法读取该文件",
  importFailed: "导入失败（{{status}}）",
  noRowsInFile: "文件中没有可读取的行",
  loadFailed: "加载失败（{{status}}）",
  deleteFailed: "删除失败（{{status}}）",
  exportFailed: "导出失败（{{status}}）",
  nDays: "{{n}} 天",
  rateNone: "无",
  locked: "已锁定",
  selectAll: "全选",
  approve: "批准",
  loadLibraryFailed: "无法加载资料库",
  readSheetFailed: "无法读取该表",
  saveFailedPlain: "无法保存",
  removeSheetFailed: "无法删除该表",
};

const dictionary = { ns: 'xPricing', en, ko, vi, zh };

export default dictionary;
